module.exports = __webpack_public_path__ + "static/img/gsx_invalidSearch.a2a9f8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gsx_invalidSearch.png
// module id = BJJJ
// module chunks = 8